<ng-container *transloco="let t">
  <h2>{{ t('auth.Loading') }}&hellip;</h2>
</ng-container>
